@let activeBanners = activeBanners$ | async;
@if (activeBanners?.length === 1) {
  <app-full-banner [content]="activeBanners[0]" [isMobile]="isMobile"></app-full-banner>
}
@if (activeBanners?.length > 1) {
  <app-split-banner [content]="activeBanners" [isMobile]="isMobile"></app-split-banner>
}
